import { render, staticRenderFns } from "./DialogFatturaPrev.vue?vue&type=template&id=116f34d6&"
import script from "./DialogFatturaPrev.vue?vue&type=script&lang=js&"
export * from "./DialogFatturaPrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports